import { useI18n, useRouter } from '@popety_io/popety-io-lib'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { estimateSelector } from '../../redux'
import EnergyHeader from './EnergyHeader'
import HeatingAndHotWaterSection from './HeatingAndHotWaterSection'
import CECBSection from './CECBSection'
import PotetialSolaireSection from './PotetialSolaireSection'
import { potentialSolar, potentialSolarColor } from './utils'
import CurrentSolaireInstalationSection from './CurrentSolaireInstalationSection'
import MonthlyAverageExposure from './MonthlyAverageExposure'
import EnergyHeatConsumptionAround from './EnergyHeatConsumptionAround'

const EstimateEnergy = () => {
  const { t } = useI18n()
  const { query, updateQuery } = useRouter()
  const estimate = useSelector(estimateSelector)

  const solarAverage = potentialSolar(t, estimate?.average_exposure)
  const solarAverageColor = potentialSolarColor(estimate?.average_exposure)

  useEffect(() => {
    if (!query.energyLayer) {
      updateQuery({ energyLayer: 'power_source_heater' })
    }
  }, [])

  const isHeatAndHot =
    estimate?.heatAndHot === undefined || estimate?.heatAndHot

  const isCecb = estimate?.CECBSection

  const isMonthlyAverageExposureSection =
    estimate?.MonthlyAverageExposureSection

  const isEnergyHeatConsumptionAroundSection =
    estimate?.EnergyHeatConsumptionAroundSection

  const iscurrentSolaireInstalation = estimate?.currentSolaireInstalation

  const isPotentialSolaire =
    estimate?.potentialSolaire === undefined || estimate?.potentialSolaire

  const isGeneva = estimate?.region_name === 'Genève'

  const heatConsumptionAroundData = useMemo(() => {
    return estimate?.heatConsumptionAround?.buckets?.map((entry: any) => {
      if (entry?.from === 550) {
        return {
          ...entry,
          renovationIndice: 550,
          color: '#FFCB60',
        }
      }

      if (entry?.from === 650) {
        return {
          ...entry,
          renovationIndice: 650,
          color: '#FC8723',
        }
      }

      if (entry?.from === 800) {
        return {
          ...entry,
          renovationIndice: 800,
          color: '#E63900',
        }
      }

      if (
        estimate.heat_consumption_index > entry?.from &&
        estimate.heat_consumption_index < entry?.to
      ) {
        return {
          ...entry,
          currentHeatConsumption: estimate.heat_consumption_index,
        }
      }

      return entry
    })
  }, [estimate?.heatConsumptionAround, estimate?.heat_consumption_index])

  return (
    <>
      <EnergyHeader data={estimate} />
      {isHeatAndHot && <HeatingAndHotWaterSection data={estimate} />}
      {isCecb && <CECBSection data={estimate} />}
      {iscurrentSolaireInstalation && (
        <CurrentSolaireInstalationSection data={estimate} />
      )}
      {isPotentialSolaire && (
        <PotetialSolaireSection
          solarAverage={solarAverage}
          solarAverageColor={solarAverageColor}
          data={estimate}
        />
      )}
      {isMonthlyAverageExposureSection && (
        <MonthlyAverageExposure
          data={estimate?.monthlyAverageExposure}
          type="estimate"
        />
      )}

      {isGeneva && isEnergyHeatConsumptionAroundSection && (
        <EnergyHeatConsumptionAround
          data={heatConsumptionAroundData}
          heatConsumptionIndex={estimate?.heat_consumption_index}
        />
      )}
    </>
  )
}

export default EstimateEnergy
